/* global ERROR_MSG, bootstrap, Vimeo, _paq, gsap, ERROR_MSG */
(function app($, utils) {
  const { qsa, qs, testEmail, checkPasswordComplexity, checkNPI, populateNPIFields, els, isElementViewport, updateValidatedField, xuFetch, domReady, formatPhoneNumber, updateSubmitBtn, bootstrapModal, validateRequiredFields, generateVCard } = utils;
  const { domainSite, nonce, userID, userNPI, isLoggedIn, notifications } = window.siteMeta;
  const queryString = window.location.search;
  const ELS = {
    ...els,
    // Form fields
    restrictName: qsa('.restrict-name'),
    phone: qsa('.phone-input'),
    // Menu
    mobileMenu: qs('.navbar-toggler'),
    menu: qs('#main-menu'),
    subMenuCoursesDiv: qs('#site-header .courses .dropdown-menu'),
    isiTray: qs('.isi-tray'),
    toggleTray: qsa('.toggle-tray'),
    links: qsa('a:not(.videoModal, .ignore-exit-modal)'),
    goLink: qs('#modalUrl .go-link'),
    eyes: qsa('form span.eye'),
    resetPassForm: qs('form[name="reset_password"]'),
    recruiterForm: qs('#recruit-friend'),
    recruiterBtn: qs('#recruit-friend button[type="submit"]'),
    notificationBanner: qs('[data-notification-banner]'),
    notificationMsgs: qs('[data-notification-msgs]'),
    notificationNum: qs('[data-notification-num]'),
    notificationTpl: qs('[data-notification-tpl]'),
    siteHeader: qs('#site-header'),
    successRegister: qs('#successRegister'),
    forgotPassForm: qs('form[name="forgot_password"]'),
    vCardLinks: qsa('a[data-generate="vcard"]'),
    toolTips: qsa('[data-bs-toggle="tooltip"]'),
    navLogo: qs('#site-header .logos__logo'),

    podcastModal: qs('#modalPodcast'),
    podcastModalEmbed: qs('#modalPodcast .embedPodcast'),
    podcastModalLinks: qsa('a.podcastModal'),

    videoModal: qs('#modalVideo'),
    videoModalEmbed: qs('#modalVideo .embedVideo'),
    videoModalLinks: qsa('a.videoModal'),

    // Search
    toggleSearchBtn: qsa('[data-toggle="search"]'),
    searchInput: qs('[data-input="search"]'),
    searchBar: qs('[data-element="search-bar"]'),

    // Case Study.
    caseStudyCollapse: qsa('.case-study-collapse .collapse, .case-study-mobile-collapse .collapse'),
    caseStudyCards: qsa('.case-study-flip-card'),
    revealPatientAnswers: qsa('[data-reveal-answer]'),
  };

  const MODAL = {
    podcast: bootstrapModal('#modalPodcast'),
    video: bootstrapModal('#modalVideo'),
    registerSuccess: bootstrapModal('#successRegister'),
    sentMail: bootstrapModal('#sentMail'),
  };

  const DESKTOP_MQ = '(min-width: 992px)';
  const MOBILE_MQ = '(max-width: 991px)';

  /**
   * The following elements need to be tracked by GTM so they need data-event-category and data-event-label added to them
   * We need an array with the selector, the category and the label
   */
  const GTM_ELEMENTS = [
        // Cookie Settings Open  
        ['button.ot-floating-button__open', 'Header', 'Cookie Settings Click'],
        // Inout Blocking - Performance Cookies Not Allowed
        ['#ot-group-id-C0002', 'Header', 'Toggle - Performance Cookies'],
        // Inout Blocking - Targeting Cookies Not Allowed
        ['#ot-group-id-C0003', 'Header', 'Toggle - Targeting Cookies'],
        // Button Accept All Cookies
        ['#accept-recommended-btn-handler', 'Header', 'Allow All'],
        // Button Reject All Cookies
        ['button.ot-pc-refuse-all-handler', 'Header', 'Reject All'],
        // Button - Confirm
        ['button.save-preference-btn-handler', 'Header', 'Confirm My Choices'],
    ];


  /**
   * GSAP global Timelines.
   */
  const TL = {
    notification: gsap.timeline({ paused: true }).fromTo(ELS.notificationBanner, {
      height: 0,
      y: 0,
    }, {
      height: 'auto',
      duration: 1,
      delay: 0.5,
      y: () => ELS.siteHeader.offsetHeight,
      ease: 'power2.out',
    }),
    search: gsap.timeline({ paused: true }).to(ELS.searchBar, { duration: 0.5, opacity: 1, display: 'flex' }),
    // Case Study Card Flip
    cardFlip: gsap.timeline({
      defaults: {
        ease: 'linear',
        duration: 0.4,
      },
      paused: true
    }),
  };

  /**
   * Animate the cross on the collapse.
   */
  function collapseOnShownHidden(e) {
    const action = e.type === 'shown.bs.collapse';
    const container = this.closest('.collapse-container');
    const path = qs('path', container);

    // Kill it if no path is found.
    if (!path) return;

    // Animate the cross
    gsap.to(path, {
      duration: 0.4,
      rotate: (i) => (action ? 90 : 0),
      transformOrigin: 'center center',
      ease: 'back.inOut(1.7)',
    });
  }

  /**
   * Scroll to a specific section using hashes.
   * @param {String} hash hash value of the section
   * @param {Int} delay delay in milliseconds.
   * 
   * Updated on 2024-06-17 - Added the opening of the accordion if the element contains one. - Waldir
   * 
   * @returns null
   */
  const scrollToHash = (hash = null, delay = 0, duration = 0.5) => {
    if (!hash) return;

    const element = qs(`${hash}_hash`) || qs(hash);

    if (!element) return;

    setTimeout(() => {
      const headerOffset = qs('#site-header') ? qs('#site-header').offsetHeight : 0;
      const scrollMarginTop = parseFloat(getComputedStyle(element).scrollMarginTop) || 0;
      const offset = scrollMarginTop || headerOffset;
      const y = element.getBoundingClientRect().top + window.pageYOffset - offset;

      gsap.to(window, {
        duration,
        scrollTo: {
          y,
          ease: 'power2',
          autoKill: false,
        },
        onComplete: () => {
          // if the element contains a toggle lets open it.
          const accordionItem = qs('.accordion-collapse', element);

          if (accordionItem) {
            new bootstrap.Collapse(accordionItem);
          }
        }
      });
    }, delay);
  }

  function dropDownsOnHover() {
    const dds = [];
    const tls = [];
    qsa('.dropdown-hover').forEach((dropdownLink, i) => {
      const menu = qs('.dropdown-menu', dropdownLink.parentNode);
      dds[i] = new bootstrap.Dropdown(dropdownLink);
      tls[i] = gsap.timeline({ paused: true }).fromTo(menu, {
        opacity: 0,
        y: -10,
        display: 'none',
      }, {
        opacity: 1,
        y: 0,
        display: 'block',
        duration: 0.3,
        ease: 'ease-out',
        onStart: () => {
          gsap.set(menu, { clearProps: 'transform' });
        },
        onComplete: () => {
          dds.forEach((dd, j) => {
            if (j !== i) {
              dd.hide();
              tls[j].reverse();
            }
          });
          dds[i].show()
        },
        onReverseComplete: () => {
          dds[i].hide();
          menu.style.transform = '';
        },
      });

      dropdownLink.addEventListener('mouseleave', (e) => {
        if (!e.toElement.closest('.dropdown-center')) tls[i].reverse();
      });
      dropdownLink.addEventListener('mouseenter', () => tls[i].play());

      /**
       * Clicking on the dropdown link should prevent the default action if the dropdown is not opened and its mobile.
       */
      dropdownLink.addEventListener('click', (e) => {
        const isMobile = window.matchMedia(MOBILE_MQ).matches;
        const menuIsOpened = menu.classList.contains('show');

        if (isMobile && !menuIsOpened)
          e.preventDefault();
      });
      menu.addEventListener('mouseleave', () => tls[i].reverse());

      // If there is a click outside of the dropdown and its opened, close it
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.dropdown-center')) {
          tls[i].reverse();
        }
      });

    });
  }

  /**
   * Dismiss notifications banner click event.
   * TODO: Make this save the state.
   */
  function dismissNotificationsClick() {
    const single = this.closest('[data-notification-single]');
    if (!single) return;

    const id = this.dataset.notificationId;

    gsap.to(single, {
      height: 0,
      onComplete() {
        single.remove();
        const num = ELS.notificationMsgs.children.length;
        ELS.notificationNum.innerHTML = `${num}&nbsp;new message${num === 1 ? '' : 's'}`;
        if (num < 1)
          TL.notification.reverse();

        xuFetch({
          action: 'dismiss_notification',
          _wpnonce: nonce.dismissNotificationForUser,
          id,
        });
      },
    });
  }

  /**
   * Check for new notifications and animate the banner.
   */
  const checkNotifications = () => {
    if (!notifications.length) return;

    ELS.notificationNum.innerHTML = `${notifications.length}&nbsp;new message${notifications.length === 1 ? '' : 's'}`;
    notifications.forEach((notification) => {
      const tpl = ELS.notificationTpl.content.cloneNode(true);
      const btn = qs('[data-notification-dismiss]', tpl);
      qs('[data-notification-title', tpl).textContent = `${notification.title}:`;
      qs('[data-notification-msg', tpl).innerHTML = notification.content;
      btn.dataset.notificationId = notification.id;
      btn.addEventListener('click', dismissNotificationsClick);
      ELS.notificationMsgs.appendChild(tpl);
    });
    // animate banner using gsap
    TL.notification.play();
  };

  const windowOnLoad = () => {
    if (!window.location.hash) return;

    // const hash      = window.location.hash.substring(1);
    const modalHash = qs(`${window.location.hash}.modal`);
    const popoverHash = qs(`${window.location.hash}.popover`);

    // Look for modals with the hash in the id.
    if (modalHash){
      bootstrapModal(modalHash).show();
    }

    // Look for popovers with the hash in the id.
    // if (popoverHash)
    //bootstrapModal(modalHash).show();


  };

  /**
   * Check for query string and show modal if needed.
   */
  const checkForQueryString = () => {
    switch (queryString) {
      case '?checkemail=confirm':
      case '?resetpass=complete':
        MODAL.sentMail.show();
        break;
      case '?success-login':
        if (+userID) {
          // TODO: Remove Matomo after.
          /*
          window._mtm.push({
            event: 'user_id',
            id: userID,
            npi: userNPI,
          });
          */
          // Push custom event to GTM
          // window.dataLayer.push({ event: 'user_login', user_id: userID, npi: userNPI });
        }
        break;
      default:
        break;
    }
  };

  /**
   * Restrict name input to letters, spaces, and hyphens.
   */
  function restrictName() {
    this.value = this.value.replace(/[^A-Za-z\s-]/gi, '');
  }

  /**
   * Restrict NPI input to numbers and 10 characters.
   */
  const npiInput = () => {
    let npiNumber = ELS.npiField.value;
    npiNumber = npiNumber.replace(/[^0-9]/gi, '');
    if (npiNumber >= 10)
      npiNumber = npiNumber.substring(0, 10);

    ELS.npiField.value = npiNumber;
  };

  const npiInputOnBlur = async () => {
    const npi = ELS.npiField.value;
    window.siteMeta.NPI_VALIDATED = false;

    if (!npi) {
      updateValidatedField(ELS.npiField, 'is-invalid', 'NPI is required.');
      return;
    }

    if (npi.length !== 10) {
      updateValidatedField(ELS.npiField, 'is-invalid', ERROR_MSG.NPI_INVALID);
      return;
    }

    const checkMyNPI = await checkNPI(npi);

    if (!checkMyNPI) {
      updateValidatedField(ELS.npiField, 'is-invalid', ERROR_MSG.NPI_INVALID);
      return;
    }

    window.siteMeta.NPI_VALIDATED = true;
    populateNPIFields(checkMyNPI);
    updateValidatedField(ELS.npiField, 'is-valid', 'NPI is valid.');
  };

  /**
   * Set the top gap for the body.
   * This is used to set the top gap for the body when the header is sticky.
   * 
   * @returns void
   */
  const setTopGap = () => {
    // Stop this from being set if the menu is open.
    if (ELS.body.classList.contains('menu-active')) return;

    ELS.element.style.setProperty('--body-top-gap', `${ELS.siteHeader.offsetHeight}px`);
  };

  /**
   * Toggle the footer active class depending on if it's in the viewport.
   */
  const onWindowScroll = () => {
    if (!ELS.footer) ELS.footer = qs('#site-footer');
    if (!ELS.isiTray) ELS.isiTray = qs('.isi-tray');

    if (ELS.isiTray) {
      ELS.footer.classList.toggle('isi-active', !isElementViewport(ELS.footer, { offset: ELS.isiTray.offsetHeight + 80 }));
    }

    // Add the class of "header-sticky" to the header when we have scrolled 100px and remove it when we are back the same 100px
    ELS.siteHeader.classList.toggle('header-sticky', window.scrollY > 100);
  };

  const onWindowResize = () => {
    setTopGap();
  }

  /**
   * Set the GTM data attributes to the elements.
   */
  const setGTMAttributes = () => {
    // Delay the setting of the attributes to make sure the elements are loaded.
    setTimeout(() => {
      GTM_ELEMENTS.forEach(([selector, category, label]) => {
        qsa(selector).forEach((el) => {
          el.dataset.eventCategory = category;
          el.dataset.eventLabel = label;
        });
      });
    }, 1000);
  }

  const setHomePopovers = () => {

    if ($('body').hasClass('home')) {

        const popOvers = qsa('[data-popover-key]');
        const CONTENT = {
          logged_in: {
            home_app_connect: {
              url: '/app-connect/'
            },
            home_webinars: {
              url: '/cme-ce-webinars/'
            }
          },
          logged_out: {
            home_app_connect: {
              body: '<p class="text-red fw-bold">(Restricted to those with an NPI)</p><p class="pt-1">Get to know other medical professionals working to advance the care and treatment of patients with epilepsy. Once connected, you can privately exchange information, knowledge, and inspiration. Simply search by name, location, or professional designation, or use the APP Connect map to locate Epilepsy Connect peers anywhere in the US.</p><div><a href="/app-connect/" class="btn btn-primary">Join APP Connect</a></div>',
              title: 'APP CONNECT'
            },
            home_webinars: {
              body: '<p class="text-red fw-bold">(Restricted to those with an NPI)</p><p class="pt-1">Learn about upcoming live and recorded webinars for CME/CE credit on Epilepsy Connect. CME/CE courses, provided by Medscape, are supported by an independent educational grant from SK Life Science, Inc. Webinars are usually <span class="text-nowrap">15-60</span> minutes, and current topics range from managing epilepsy in pediatric populations and older patients in long-term care to emerging trends in anti-seizure medications and preventing SUDEP (sudden unexpected death in epilepsy).</p><div><a href="/cme-ce-webinars/" class="btn btn-primary">Explore Webinars</a></div>',
              title: 'Webinars FOR<br>CME/CE CREDIT'
            }
          }
        };

        popOvers.forEach(btn => {
          
            const userState = isLoggedIn && userNPI !== '' ? 'logged_in' : 'logged_out';
            const key = btn.dataset.popoverKey;
            const data = CONTENT[userState][key];

            if (userState === 'logged_out'){
              
              const popover = new bootstrap.Popover(btn, {
                container: '.col-map',
                content: data.body,
                customClass: 'custom-popover',
                html: true,
                placement: 'auto',
                title: data.title,
                trigger: 'focus'
              });
            }

            if ( (window.location.hash.includes('webinars') && key == 'home_webinars') || (window.location.hash.includes('appconnect') && key == 'home_app_connect')){
                btn.focus();
            }

            btn.addEventListener('click', (e) => {
                e.preventDefault();

                if (userState === 'logged_in'){

                  window.location = data.url;

                } else {
                  btn.focus();
                }
            });
        });
    }
  }


  const init = () => {
    setGTMAttributes();
    checkForQueryString();
    checkNotifications();
    dropDownsOnHover();
    setTopGap();

    scrollToHash(window.location.hash, 300);
    setHomePopovers();
    window.addEventListener('hashchange', () => scrollToHash(window.location.hash, 300));
    window.addEventListener('resize', onWindowResize);

    window.addEventListener('load', windowOnLoad);
    window.addEventListener('scroll', onWindowScroll);
    ELS.restrictName.forEach(input => input.addEventListener('input', restrictName));


    if (qs('body.enrollment-form')){
        ELS.npiField.addEventListener('input', npiInput);
        ELS.npiField.addEventListener('blur', npiInputOnBlur);
    

        // Toggle the checkboxes validation when they change.
        ELS.understand.addEventListener('change', () => ELS.understand.classList.toggle('is-invalid', !ELS.understand.checked));
        ELS.understandNoNPI.addEventListener('change', () => (ELS.understandNoNPI.classList.contains('required') && ELS.understandNoNPI.classList.toggle('is-invalid', !ELS.understandNoNPI.checked)));

        //ELS.wcpForm.addEventListener('submit', e => e.preventDefault());
    }

    // Init tooltips
    ELS.toolTips.forEach((tooltip) => {
      tooltip.dataset.bsCustomClass = 'custom-tooltip';
      tooltip.dataset.bsHtml = true;
      new bootstrap.Tooltip(tooltip)
    });

    // Generate vCard Links
    ELS.vCardLinks.forEach((link) => {
      const { firstName, lastName, address, phoneNumber, email } = link.dataset;
      link.href = generateVCard(firstName, lastName, address, phoneNumber, email);
      link.download = `${firstName}-${lastName}.vcf`;
    });

    // Format phone number input to (999) 999-9999.
    ELS.phone.forEach(input => {
      const numberCB = () => {
        input.value = formatPhoneNumber(input.value);
      };
      input.addEventListener('input', numberCB);
      input.addEventListener('blur', numberCB);
    });

    
    // The logo transitions so adjust the top gap when the transition is done.
    ELS.navLogo.addEventListener('transitionend', setTopGap);

    /**
     * Open the video modal and play the video.
     */
    ELS.videoModalLinks.forEach((videoLink) => videoLink.addEventListener('click', (e) => {
      e.preventDefault();

      const loadingText = qs('h6', ELS.videoModal);
      const videoTitle = qs('h2', ELS.videoModal);

      // remove https:// from href
      let linkVideo = videoLink.href.replace('https://', '');
      linkVideo = linkVideo.split('?'); // Split by ?
      const [, videoID, videoHash] = linkVideo[0].split('/'); // Split by /
      

      const title = qs('h6', videoLink.parentNode) ? qs('h6', videoLink.parentNode).innerHTML : '';
      const videoURL = `https://player.vimeo.com/video/${videoID}/?h=${videoHash}${isLoggedIn ? '&badge=0&autopause=0&player_id=0&app_id=58479' : ''}}`;
      const iframe = document.createElement('iframe');
      iframe.src = videoURL;
      iframe.frameborder = 0;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowfullscreen = true;
      const player = new Vimeo.Player(iframe);

      // Adjust the modal to the video
      gsap.to(loadingText, { opacity: 1, duration: 0.5 });
      ELS.videoModalEmbed.appendChild(iframe);

      // Send the event to Matomo
      // _paq.push(['MediaAnalytics::scanForMedia']);

      // Play the video
      if(videoTitle){
        videoTitle.innerHTML = title;
      }
      
      MODAL.video.show();
      player.play();
      var currentVideoID = videoID;
      setTimeout(() => gsap.to(loadingText, { opacity: 0, duration: 0.5 }), 2000);

      trackVideo(player, currentVideoID);

      if (!isLoggedIn) return;

      xuFetch({
        action: 'saveVideo',
        _wpnonce: nonce.saveVideo,
        videoID,
      }, );
    }));

    /**
     * Open the podcast modal and play the audio.
     */
    ELS.podcastModalLinks.forEach((podcastLink) => podcastLink.addEventListener('click', (e) => {
      e.preventDefault();

      const podcastTitle = qs('h2', ELS.podcastModal);
      const title = qs('h6', podcastLink.parentNode) ? qs('h6', podcastLink.parentNode).innerHTML : '';
      const audio = document.createElement('audio');

      audio.src = podcastLink;
      audio.preload = 'metadata';
      audio.controls = true;
      audio.setAttribute('aria-label', title);

      ELS.podcastModalEmbed.appendChild(audio);

      if(podcastTitle){
        podcastTitle.innerHTML = title;
      }

      MODAL.podcast.show();

      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }

      if (ELS.podcastModal._hasCloseListener){
        return;
      } 

      ELS.podcastModal.addEventListener('hide.bs.modal', (event) => {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;

          ELS.podcastModalEmbed.innerHTML = '';
        }
      });

      ELS.podcastModal._hasCloseListener = true;

      
    }));

    /**
     * Collapse the case study.
     */
    ELS.caseStudyCollapse.forEach((collapse) => {
      collapse.addEventListener('hidden.bs.collapse', collapseOnShownHidden);
      collapse.addEventListener('shown.bs.collapse', collapseOnShownHidden);
    });

    /**
     * Flip the case study card.
     */
    ELS.caseStudyCards.forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        const container = card.closest('.case-study-flip-card__container');
        const isFront = card.classList.contains('case-study-flip-card__front');
        const cardFront = isFront ? card : qs('.case-study-flip-card__front', card.parentElement);
        const cardBack = !isFront ? card : qs('.case-study-flip-card__back', card.parentElement);

        container.style.perspective = `${container.offsetWidth * 2}px`;

        TL.cardFlip
          .addLabel('start')
          .fromTo(cardFront, { rotationY: isFront ? 0 : -180 }, { rotationY: isFront ? -180 : 0 }, 'start')
          .fromTo(cardBack, { rotationY: isFront ? 180 : 0 }, { rotationY: isFront ? 0 : 180 }, 'start')
          .play();
      });
    });

    // Ann an event listener that triggers the next/prev tab when clicked.
    $('.tab-next-btn, .tab-prev-btn').on('click', function f() {
      const direction = this.classList.contains('tab-next-btn') ? 'next' : 'prev';
      $(this.dataset.tabs).find('.nav-link.active')[direction]('.nav-link').trigger('click')
        .get(0)
        .scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });

    ELS.revealPatientAnswers.forEach(element => {
      element.addEventListener('click', () => {
        const patientAnswer = qs(element.dataset.revealAnswer);
        console.log(patientAnswer, element.dataset.revealAnswer)
        if (!patientAnswer) return;

        gsap.timeline()
          .to(element, { display: 'none', duration: 0 })
          .to(patientAnswer, { opacity: 1, display: 'block', duration: 0.5 })
      })
    });
  };

  var milestones = [25, 50, 75, 100];
  var milestonesReached = [];

  function trackVideo(player, currentVideoID) {
      var videoTitle = new String();
      player.getVideoTitle().then(function(title) {
          videoTitle = title;
      });
      var videoID = new String();
      player.getVideoId().then(function(id) {
          videoID = id;
      });

      player.on('play', function(data, currentVideoID) {
          if(videoID != currentVideoID) {
            milestonesReached = [];
          }
          pushData(player, "play", videoTitle, videoID, (data.percent.toFixed(2) * 100))
      });

      player.on('timeupdate', function(data) {
          milestones.forEach(function(milestone) {
              if ((data.percent.toFixed(2) * 100) >= milestone && milestonesReached.indexOf(milestone) === -1) {
                  milestonesReached.push(milestone);
                  pushData(player, "progress", videoTitle, videoID, milestone);
              }
          });
      });

      player.on('pause', function(data) {
          pushData(player, "pause", videoTitle, videoID, (data.percent.toFixed(2) * 100))
      });
  }

  function pushData(player, action, videoTitle, videoID, progress) {
      var videoURL = "https://vimeo.com/" + videoID;
      dataLayer.push({
          event: "video",
          video_action: action,
          video_title: videoTitle,
          video_id: videoURL,
          video_percent: progress
      });
  }


  /**
   * This seems to be a download video of a PDF instead of a video.
   */
  qsa('a.downloadAsset').forEach((download) => {
    if (!isLoggedIn) return;
    download.addEventListener('click', () => {
      xuFetch({
        action: 'saveDownload',
        _wpnonce: nonce.saveDownload,
        id: download.dataset.id
      }, );
    });
  });

  // Toggle menu.
  ELS.mobileMenu.addEventListener('click', () => {
    ELS.mobileMenu.classList.toggle('change');
    ELS.menu.classList.toggle('active');
    ELS.body.classList.toggle('menu-active');
  });

  qsa('li a', ELS.menu).forEach(link => ELS.subMenuCoursesDiv.classList.remove('removeHover'));
  qsa('li ul li a', ELS.menu).forEach((link) => {
    link.addEventListener('click', () => {
      ELS.mobileMenu.classList.remove('active');
      ELS.menu.classList.remove('active');
      // ELS.$subMenuCoursesDiv.addClass('removeHover');
      // ELS.subMenuCoursesDiv.classList.add('removeHover');
    });
  });

  // Toggle ISI tray body class.
  ELS.toggleTray.forEach(toggle => toggle.addEventListener('click', () => ELS.body.classList.toggle('active-isi')));
  
  ELS.links.forEach((link) => {
    if (link.href.indexOf('javascript') > -1 || link.href.indexOf(domainSite) > -1 || link.href === '' || link.href === '#' || link.parentElement.classList.contains('ignore-exit-modal'))
      return;

    link.removeAttribute('target');
    link.setAttribute('data-link', link.href);
    link.href = '#';
    link.setAttribute('data-bs-toggle', 'modal');
    link.setAttribute('data-bs-target', '#modalUrl');
    link.classList.add('modalLink');
  });

  // When the modalLink is clicked, set the href of the modal button to the link.
  ELS.body.addEventListener('click', (e) => {
    if (e.target.matches('.modalLink') || e.target.closest('.modalLink'))
      ELS.goLink.href = e.target.dataset.link || e.target.closest('.modalLink').dataset.link;
  });

  // When the go btn is clicked in the modal, open the link in a new tab.
  ELS.goLink.addEventListener('click', () => window.open(ELS.goLink.href, '_blank'));

  // Toggle password visibility.
  ELS.eyes.forEach((eye) => {
    const input = qs('input', eye.parentElement);
    eye.addEventListener('click', () => {
      const isActive = eye.classList.contains('active');
      input.setAttribute('type', isActive ? 'password' : 'text');
      eye.classList.toggle('active');
    });
  });

  /**
   * Send a recruit request to a friend.
   * TODO: Remove contact form 7.
   */
  if (ELS.recruiterForm){
      ELS.recruiterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        let valid = true;
        const nameFriend = qs('.friend', ELS.recruiterForm);
        const emailFriend = qs('.friendEmail', ELS.recruiterForm);

        qsa('.is-invalid', ELS.recruiterForm).forEach(el => el.classList.remove('is-invalid'));

        updateSubmitBtn('Sending...', ELS.recruiterBtn);

        if (nameFriend.value.length < 2) {
          updateValidatedField(nameFriend, 'is-invalid');
          valid = false;
        }

        if (!testEmail(emailFriend.value)) {
          updateValidatedField(emailFriend, 'is-invalid');
          valid = false;
        }

        if (!valid) {
          updateSubmitBtn('__default__', ELS.recruiterBtn);
          return
        };

        xuFetch({
            action: 'recruit_friend',
            _wpnonce: nonce.recruitFriend,
            friendName: nameFriend.value,
            friendEmail: emailFriend.value,
          },
          null,
          null,
          // Finally
          () => {
            bootstrapModal('#recruitMember').show();
            updateSubmitBtn('__default__', ELS.recruiterBtn);
            // reset form
            ELS.recruiterForm.reset();
          }
        );
      });
  }

  if (ELS.forgotPassForm){

      ELS.forgotPassForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const userLogin = qs('#user_login', ELS.forgotPassForm);

        // reset errors
        userLogin.classList.remove('is-invalid', 'is-valid');

        updateSubmitBtn('Please wait...', ELS.forgotPassForm.submit);

        // If the user_login is empty, show error.
        if (!userLogin.value) {
          updateValidatedField(userLogin, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
          updateSubmitBtn('__default__', ELS.forgotPassForm.submit);
          return;
        }

        // Too short
        if (userLogin.value.length < 3) {
          updateValidatedField(userLogin, 'is-invalid', 'Username or email address is too short.');
          updateSubmitBtn('__default__', ELS.forgotPassForm.submit);
          return;
        }

        // Send it over to the server.
        xuFetch(
          ELS.forgotPassForm,
          // success
          (res) => {
            const { success, data } = res;
            updateValidatedField(userLogin, 'is-valid', data);
            updateSubmitBtn('Success!', ELS.forgotPassForm.submit);
            // Open the modal.
            MODAL.sentMail.show();
          },
          // Error
          (error) => {
            const { data } = error;
            updateValidatedField(userLogin, 'is-invalid', data);
            updateSubmitBtn('Error', ELS.forgotPassForm.submit, false);
          },
        );
      });
  }

  // When the video modal is hidden, remove the video.
  ELS.videoModal.addEventListener('hide.bs.modal', () => { ELS.videoModalEmbed.innerHTML = ''; });

  if (ELS.resetPassForm){
      ELS.resetPassForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const pass1 = qs('#user_pass', ELS.resetPassForm);
        const pass2 = qs('#user_pass_confirm', ELS.resetPassForm);

        // reset errors
        qsa('.is-invalid, .is-valid', ELS.resetPassForm).forEach(el => el.classList.remove('is-invalid', 'is-valid'));

        updateSubmitBtn('Saving...', ELS.resetPassForm.submit);

        if (pass1.value.length < 8) {
          updateValidatedField(pass1, 'is-invalid', ERROR_MSG.PASS_MIN_LENGTH);
          updateSubmitBtn('__default__', ELS.resetPassForm.submit);
          return;
        }

        if (!checkPasswordComplexity(pass1.value)) {
          updateValidatedField(pass1, 'is-invalid', ERROR_MSG.PASS_ERROR);
          updateSubmitBtn('__default__', ELS.resetPassForm.submit);
          return;
        }

        if (pass1.value !== pass2.value) {
          updateValidatedField(pass2, 'is-invalid', ERROR_MSG.PASS_CONFIRM_NOT_MATCH);
          updateSubmitBtn('__default__', ELS.resetPassForm.submit);
          return;
        }

        // Send it over to the server.
        xuFetch(
          ELS.resetPassForm,
          // success
          (res) => {
            const { data } = res;
            // add the msg after the form
            ELS.resetPassForm.insertAdjacentHTML('afterend', `<div class="">${data}</div>`);
            // remove the form
            ELS.resetPassForm.remove();
          },
          // Error
          (error) => {
            const { data } = error;
            updateValidatedField(pass1, 'is-invalid', ERROR_MSG[data] || data);
            updateSubmitBtn('Error', ELS.resetPassForm.submit, false);
          },
        );
      });
  }

  // Search Toggle
  ELS.toggleSearchBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();



      // First the first visible search button so that we can move the search bar after it.
      const firstVisibleSearchBtn = ELS.toggleSearchBtn.filter((btn) => btn.offsetParent !== null)[0];
      // IF the ELS.searchBar is not already after 
      // the very first button that is visible on the page, move it there.
      if (ELS.searchBar.previousElementSibling !== firstVisibleSearchBtn) {
        firstVisibleSearchBtn.after(ELS.searchBar);
      }
      // If its already open, close it.
      if (ELS.body.classList.contains('search-active')) {
        ELS.body.classList.remove('search-active');
        TL.search.reverse();
        return;
      }

      ELS.body.classList.toggle('search-active');

      setTimeout(() => {
        ELS.searchInput.focus();
      }, 100);

      TL.search.play();

    });
  });

  // Close the search form when the user clicks outside of it making sure its not opened already.
  // Also make sure that a button thats
  document.addEventListener('click', (e) => {
    if (
      ELS.body.classList.contains('search-active') &&
      !e.target.closest('[data-element="search-bar"]') &&
      !e.target.closest('[data-toggle="search"]')
    ) {
      console.log('close search', e.target);

      ELS.body.classList.remove('search-active');
      TL.search.reverse();
    }
  });

  if ($(".case-study-collapse").length) {
      function normalizeAccordionBodyHeights() {
          // Target every carousel on page
          $('.case-study-collapse').each(function(){
          // Put all .carousel-item in array
          var items = $('.accord-body', this);
          // Set min-height to 0px
          items.css('min-height', 0);
          // Set min-height to the tallest item's height
          var tallestItemHeight = Math.max.apply(null, 
              items.map(function(){
                  return $(this).outerHeight()}).get() );
          items.filter('.show').css('min-height', tallestItemHeight + 'px');
          })
      }
      
    // On load/resize: normalize (safe)
    $(window).on('load resize orientationchange', normalizeAccordionBodyHeights);

    // Before Bootstrap starts animating, remove min-height so height can transition
    $(document).on('show.bs.collapse hide.bs.collapse', '.case-study-collapse .accord-body', function () {
      $(this).css('min-height', 0);
    });

    // After opening finishes, apply equal height
    $(document).on('shown.bs.collapse', '.case-study-collapse .accord-body', normalizeAccordionBodyHeights);

    // Optional: after closing finishes, re-normalize (keeps things consistent)
    $(document).on('hidden.bs.collapse', '.case-study-collapse .accord-body', normalizeAccordionBodyHeights);
  }

  // if ($(".case-study-flip-card-container").length) {
  //   function normalizeFlipCardHeights() {
  //       // Target every container on page
  //       $('.case-study-flip-card__group').each(function(){
  //       // Put all .case-study-flip-card in array
  //       var items = $('.case-study-flip-card', this);
  //       // Set min-height to 0px
  //       items.css('min-height', 0);
  //       // Set min-height to the tallest item's height
  //       var tallestItemHeight = Math.max.apply(null, 
  //           items.map(function(){
  //               return $(this).outerHeight()}).get() );
  //       items.css('min-height', tallestItemHeight + 'px');
  //       })
  //   }
    
  // $(window).on('load resize orientationchange', normalizeFlipCardHeights);

  // $(document).on('click', '[data-bs-toggle="tab"], [data-toggle="tab"]', function () {
  //   setTimeout(normalizeFlipCardHeights, 0);
  // });

  // }


  // Init
  domReady(init);
}(jQuery, window.utilities));
